import styles from './ListItem.module.css';

import type { FC, HTMLAttributes } from 'react';

export interface ListItemProps extends HTMLAttributes<HTMLDivElement> {
  number: number;
  title: string;
  description: string;
}

const ListItem: FC<ListItemProps> = (props) => {
  const { number, title, description } = props;
  const correctNumber = number > 9 ? number : `0${number}`;

  return (
    <div className={styles.wrapper}>
      <div className={styles.number}>{correctNumber}</div>
      <div>
        <div className={styles.title}>{title}</div>
        <div className={styles.description}>{description}</div>
      </div>
    </div>
  );
};

export default ListItem;
